module.exports = __webpack_public_path__ + "img/vertical_4_2_3016.9cec4aac.png";